import { DATE_FORMAT } from "app/constants";
import { format, toDate, utcToZonedTime } from "date-fns-tz";

const BROWSER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export default function getLongDate(date?: string) {
  const zonedDate = date
    ? utcToZonedTime(
        toDate(`${date}`, {
          timeZone: BROWSER_TIMEZONE,
        }),
        BROWSER_TIMEZONE
      )
    : "";

  return format(zonedDate as Date, DATE_FORMAT, {
    timeZone: BROWSER_TIMEZONE,
  });
}
